<template>
    <tr :style="{'cursor': 'pointer'}" @click="handleItemClick">
        <td>{{ item.code }}</td>
        <td>{{ item.title | NoEmpty }}</td>
        <td>{{ item.price | currency}}</td>
    </tr>
</template>

<script>
    import NoEmpty from '../../Filters/NoEmpty'

    export default {
        name: 'ServiceItem',
        props: {
            item: {
                type: Object
            }
        },
        filters: {
            NoEmpty
        },
        methods: {
            handleItemClick() {
                this.$emit('click', this.item)
            }
        }
    }
</script>

<style scoped>

</style>